import { memo } from 'react';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { useCountdown } from 'root/src/client/v2/common/hooks/useCountdown';
import { getDateWithTimezone } from 'root/src/shared/util/getDateWithTimezone';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from 'root/src/client/v2/common/components/ui/tooltip';
import { formatTimeLeft } from 'root/src/client/v2/common/helpers/formatTimeLeft';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Compact ticking "time left until this dare expires" chip for redesign dare cards / hero images.
// Purely presentational: it renders nothing once the countdown runs out, and callers decide whether a
// dare is eligible for a counter at all (see getDareTimeLeft, which zeroes delivered / unapproved
// dares). Ticks client-side, so it must only ever render on the client (all redesign pages fetch
// their data client-side, so no hydration mismatch).
export const DareTimeLeftChip = memo(({ expirationDate, className }) => {
    const { timeLeft } = useCountdown(expirationDate !== null && expirationDate !== void 0 ? expirationDate : '');
    if (!expirationDate || Number.isNaN(timeLeft) || timeLeft <= 0) {
        return null;
    }
    return (<TooltipProvider delayDuration={150}>
			<Tooltip>
				<TooltipTrigger asChild>
					<span className={cn('inline-flex items-center gap-1.5 rounded-md border border-solid border-neon-cyan/40 bg-black/60 px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-neon-cyan shadow-sm backdrop-blur-md', className)}>
						<ScheduleIcon sx={{ fontSize: 14 }}/>
						<span className="tabular-nums">{formatTimeLeft(timeLeft)}</span>
					</span>
				</TooltipTrigger>
				<TooltipContent>Ends at: {getDateWithTimezone(expirationDate)}</TooltipContent>
			</Tooltip>
		</TooltipProvider>);
});
